import { lazyWithRetry } from "utils/lazy-with-retry";
import AdminRoute from "components/admin-route";

const baseAdminLayout = [
  {
    path: "/admin",
    element: lazyWithRetry(() => import("view/admin/dashboard")),
    isProtected: true,
    requiresAdmin: true,
    wrapper: AdminRoute,
  },
  {
    path: "/admin/dashboard",
    element: lazyWithRetry(() => import("view/admin/dashboard")),
    isProtected: true,
    requiresAdmin: true,
    wrapper: AdminRoute,
  },
  {
    path: "/admin/users",
    element: lazyWithRetry(() => import("view/admin/users/user-list")),
    isProtected: true,
    requiresAdmin: true,
    wrapper: AdminRoute,
  },
  {
    path: "/profileedit/:userId",
    element: lazyWithRetry(() => import("view/profile/edit")),
    isProtected: true,
    requiresAdmin: true,
    wrapper: AdminRoute,
  },
  {
    path: "/admin/analytics",
    element: lazyWithRetry(() => import("view/admin/analytics")),
    isProtected: true,
    requiresAdmin: true,
    wrapper: AdminRoute,
  },
  {
    path: "/admin/settings",
    element: lazyWithRetry(() => import("view/admin/settings")),
    isProtected: true,
    requiresAdmin: true,
    wrapper: AdminRoute,
  },
];

const adminRoutes = {
  adminLayout: [
    ...baseAdminLayout,
    ...baseAdminLayout.map((route) => ({
      ...route,
      path: route.path.endsWith("/") ? route.path : `${route.path}/`,
    })),
  ],
};

export default adminRoutes;
